export const baseUrlQA = "https://api.mytrumpf.com.qa.tru";
export const baseUrlProd = "https://api.mytrumpf.com";
export const useMockData = process.env.USE_MOCK_API === "true";
export const apiVersion = "4.19";
export const clientType = "ServiceApp";
